import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

export const getCoinsList = async ({ impulse_type, impulse_id, base_asset_id, page, type, category }) => {
  const url = `${backendUrl}/api/screener/${ impulse_type }/coins/?${impulse_id}&base_asset_id=${base_asset_id}&type=${type}&page=${page}&${category}&page_size=100`;
  console.log(url);
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };

  try {
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Ошибка сети при получении импульсов: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.error('Ошибка при получении импульсных данных:', error);
    throw error;
  }
};